const shippingTransportationMethods = [
  { value: "road", label: "Truck" },
  { value: "sea", label: "Ship" },
  { value: "air", label: "Air" },
  { value: "rail", label: "Train" },
];

export { shippingTransportationMethods };
